export default {
    GET_ORDERS_IN_PROGRESS: (state, data) => {
        state.ordersInProgress = data.results
    }
}